export default __webpack_public_path__ + "static/media/Tradicional.603700f2.svg";